module.exports = __webpack_public_path__ + "img/green-increase.8e2cc24e.svg";